/** Program facts — single source of truth for age and reach (WD-05). */
export const facts = {
  ageSentence: 'footyLab is designed for ages 10–14; ask about other ages.',
  studentsReach: '200+ Students',
  studentsContext: 'Reached through Knoxville schools, clubs, and nonprofits.',
  studentsNote: 'Owner-supplied program reach, not a measured learning-effect statistic.',
  studentsAsOf: '2025',
  studentsApprovedBy: 'Gus (WD-00/brief)',
};
